export var updateFoodsEvent = "updateFoods";
